
  import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Image, Card } from 'react-bootstrap';
import { useNavigate ,useParams } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import throttle from 'lodash.throttle';
import { CgProfile } from "react-icons/cg";
import { MdLocationPin } from "react-icons/md";
import './ChangeTheme.css'; // Import your CSS file for custom styles
import { BASE_URL_API } from '../environment';
import { CiShare2 } from "react-icons/ci";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaHome, FaTag, FaStore, FaCalendarAlt } from "react-icons/fa";
import { Nav } from 'react-bootstrap';
import { PiBracketsSquareBold } from "react-icons/pi";




const ThemeSelector = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // Added for edit mode
    const [festivalLogoFile, setFestivalLogoFile] = useState(null); // New state for logo file
    const [festivalName, setFestivalName] = useState(''); 
    const [submitting, setSubmitting] = useState(false); // New state to prevent multiple submits
    const [customStyles, setCustomStyles] = useState({
      ionBackgroundColor: '#ffffff',
      ionColorPrimary: '#3a7713',
      ionColorSecondary: '#73be44',
      ionColorTertiary: '#efffdb',
      ionHeadingColor: '#3a7713',
      ionSubheadingColor: '#73be44',
      ionTextColor: '#000000',
      ionLogoColor: '#ffffff',
      ionCardBackground: '#1e1e1e',
      ionToolbarBackground: '#1f1f1f',
      ionTabBarBackground: '#1f1f1f',
      festivalEffect: 'none',
    });
    const [startDateTime, setStartDateTime] = useState('');
    const [endDateTime, setEndDateTime] = useState('');
    const [festiveFile, setFestiveFile] = useState(null);
    const [effectFile, setEffectFile] = useState(null); // New state for effect file

    // Inside your component, add state for tooltip visibility
    const [hoveredColor, setHoveredColor] = useState(null);

    // Fixed: Handle both color inputs and select dropdown
    const handleStyleChange = (key, value) => {
      setCustomStyles((prev) => ({ ...prev, [key]: value }));
    };

    // Load theme for editing
    useEffect(() => {
        if (id) {
          const fetchTheme = async () => {
            try {
              const response = await fetch(`${BASE_URL_API}themes/${id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
              });
              if (response.ok) {
                const theme = await response.json();
                setFestivalName(theme.name);
                setCustomStyles({
                    ...theme.colors,
                    festivalEffect: theme.effect || 'none', // Preserve effect from backend
                    festiveEffect: theme.festiveEffect || '', // Reflect uploaded path
                  });// Assuming colors includes festivalEffect
                setStartDateTime(theme.startDateTime.slice(0, 16)); // Format for datetime-local
                setEndDateTime(theme.endDateTime.slice(0, 16));
              }
            } catch (error) {
              console.error('Error fetching theme:', error);
            }
          };
          fetchTheme();
        }
    }, [id]);
  
  
const [submitCount, setSubmitCount] = useState(0); //use state for handlling submit count
const handleSubmit = async () => {
    setSubmitCount((prev) => prev + 1);
  console.log(`Submission attempt #${submitCount}`);
    if (submitting) return; // Prevent multiple submits
      if (!festivalName) {
        alert('Please enter a festival or event name!');
        return;
      }

    //   if (!startDateTime || !endDateTime) {
    //     alert('Please select both start and end date & time!');
    //     return;
    //   }

    //   if (new Date(startDateTime) >= new Date(endDateTime)) {
    //     alert('Start date and time must be before the end date and time!');
    //     return;
    //   }
      setSubmitting(true); // Lock submission
      const payload = {
        name: festivalName, 
        colors: {
          ionBackgroundColor: customStyles.ionBackgroundColor,
          ionColorPrimary: customStyles.ionColorPrimary,
          ionColorSecondary: customStyles.ionColorSecondary,
          ionColorTertiary: customStyles.ionColorTertiary,
          ionHeadingColor: customStyles.ionHeadingColor,
          ionSubheadingColor: customStyles.ionSubheadingColor,
          ionTextColor: customStyles.ionTextColor,
          ionLogoColor: customStyles.ionLogoColor,
          ionCardBackground: customStyles.ionCardBackground,
          ionToolbarBackground: customStyles.ionToolbarBackground,
          ionTabBarBackground: customStyles.ionTabBarBackground,
        },
        effect: customStyles.festivalEffect,
        startDateTime,
        endDateTime,
      };
      console.log("payload", payload);

      //here the new logic added for file upload

      try {
        let festiveEffectPath = ''; // To store uploaded file path
        if (festiveFile) {
          const formData = new FormData();
          console.log('what is this form data can i see it ', formData);
          formData.append('festiveEffect', festiveFile);
          formData.append('theme', JSON.stringify(payload));
          console.log('what is this form data can i see it ', formData);
          const uploadUrl = id ? `${BASE_URL_API}themes/upload-effect/${id}` : `${BASE_URL_API}themes/upload-effect`;
          const uploadResponse = await fetch(uploadUrl, {
            method: 'POST',
            body: formData,
          });
          if (uploadResponse.ok) {
            console.log("show me what is this uploadresponse", uploadResponse);
            const result = await uploadResponse.json();
            festiveEffectPath = result.festiveEffect; // Path from API (e.g., /uploads/filename.json)
          } else {
            throw new Error('File upload failed');
          }
        }
  //this is for handling logo of app

  let festivalLogoPath = '';
    if (festivalLogoFile) {
      const logoFormData = new FormData();
      logoFormData.append('festivalLogo', festivalLogoFile);
      logoFormData.append('theme', JSON.stringify(payload));
      const logoResponse = await fetch(`${BASE_URL_API}themes/upload-logo/${id || ''}`, {
        method: 'POST',
        body: logoFormData,
      });
      if (logoResponse.ok) {
        const result = await logoResponse.json();
        festivalLogoPath = result.festivalLogo;
      } else {
        throw new Error('Festival logo upload failed');
      }
    }
        // Add festiveEffect path to payload if uploaded
        if (festiveEffectPath) {
          payload.festiveEffect = festiveEffectPath;
        }
  if (festivalLogoPath) payload.festivalLogo = festivalLogoPath;


// Handle new festive effect (Lottie JSON) upload
let festiveEffectPath1 = '';
if (effectFile) {
  const formData = new FormData();
  formData.append('effect', effectFile); // Reuse upload-effect for new effect
  formData.append('theme', JSON.stringify(payload));
  const uploadUrl = id ? `${BASE_URL_API}themes/upload-festive-effect/${id}` : `${BASE_URL_API}themes/upload-festive-effect`;
  const uploadResponse = await fetch(uploadUrl, {
    method: 'POST',
    body: formData,
  });
  if (uploadResponse.ok) {
    console.log("show me what is this uploadresponse for effect", uploadResponse);
    const result = await uploadResponse.json();
    festiveEffectPath1 = result.effect; // Path for new festive effect
  } else {
    throw new Error('Festive effect upload failed');
  }
}
if (festiveEffectPath1) payload.effect = festiveEffectPath1; //
  //single save call to save all the data at db
        const url = id ? `${BASE_URL_API}themes/${id}` : `${BASE_URL_API}themes/tosent`;
        const method = id ? 'PUT' : 'POST';
        console.log(`Saving to ${url} with method ${method}`);
     
        const response = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
  
        if (response.ok) {
          console.log(id ? 'Theme updated:' : 'Theme saved:', payload);
          navigate('/dashboard/themelist');
        } else {
            const errorData = await response.json();
            console.error('Error creating theme:', errorData);
            alert(errorData.error || 'Failed to create theme'); // Show the specific error from backend
          }
      } catch (error) {
        console.error('Error saving/updating theme:', error);
      }
      finally {
        setSubmitting(false); // Unlock after done
      }
    };
  
    return (
        <Container fluid className="theme-selector-container py-4">
          <Row>
            <Col md={6} className="theme-form">
              <h2 className="theme-title">{id ? 'Edit Theme' : 'Create New Theme'}</h2>
              <Form onSubmit={(e) => e.preventDefault()}> {/* Prevent form default submission */}
                <Form.Group className="mb-4">
                  <Form.Label className="form-label">Festival/Event Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={festivalName}
                    onChange={(e) => setFestivalName(e.target.value)}
                    placeholder="e.g., Diwali, Birthday Party"
                    className="form-input"
                  />
                </Form.Group>
           `         <div className="color-grid">
                    {[
                            { label: 'Background', id: 'background-color', key: 'ionBackgroundColor' ,showTooltip: true, appliedTo: ['All pages Background']},
                            { label: 'Base Color', id: 'main-action-color', key: 'ionColorPrimary', showTooltip: true, appliedTo: ['Dashboard Impact Button', 'Sell Scrap Submit Button'] }, // Add your content here
                            { label: 'Highlight Color', id: 'highlight-color', key: 'ionColorSecondary', showTooltip: true, appliedTo: ['Dashboard Pickups Card', 'Referal container', 'EcoShop Item Background'] }, // Add your content here
                            { label: 'ToolBar color', id: 'accent-color', key: 'ionColorTertiary', showTooltip: true, appliedTo: ['Toolbar Background', 'Address Bar Background','Referal Container of dashboard','Cards of Events page on hovering'] }, // Add your content here
                            { label: 'Heading', id: 'heading-color', key: 'ionHeadingColor', showTooltip: true, appliedTo: ['Header Text', 'Address Bar Text','Tabs Icons when selected', 'Dashboard Header Text'] }, // Add your content here
                            { label: 'Subheading', id: 'subheading-color', key: 'ionSubheadingColor' ,showTooltip: true, appliedTo: ['Subheading Text'] }, // Add your content here
                            { label: 'Text', id: 'text-color', key: 'ionTextColor',showTooltip: true, appliedTo: ['applied to Text in most pages '] },
                            { label: 'Logo', id: 'logo-color', key: 'ionLogoColor',showTooltip: true, appliedTo: ['Logo in some pages'] },
                            { label: 'Card BG', id: 'card-bg-color', key: 'ionCardBackground',showTooltip: true, appliedTo: ['Dashboard Cards'] },
                            { label: 'Toolbar BG', id: 'toolbar-bg-color', key: 'ionToolbarBackground',showTooltip: true, appliedTo: ['Header Background', 'Address Bar Background'] },
                            { label: 'Tab Bar BG', id: 'tab-bar-bg-color', key: 'ionTabBarBackground' ,showTooltip: true, appliedTo: ['Tab Bar Background'] }, // Add your content here
                            ].map(({ label, id, key ,showTooltip, appliedTo}) => (
                            <div className="color-card" key={id}
                            onMouseEnter={() => setHoveredColor(id)}
                            onMouseLeave={() => setHoveredColor(null)}
                            >
                                <Form.Label className="form-label" htmlFor={id}>
                                {label}
                                </Form.Label>
                                <Form.Control
                                type="color"
                                id={id}
                                value={customStyles[key]}
                                onChange={(e) => handleStyleChange(key, e.target.value)}
                                className="color-circle"
                                title={`Select ${label.toLowerCase()} color`}
                                />
                                <Form.Control
                                type="text"
                                value={customStyles[key]}
                                onChange={(e) => handleStyleChange(key, e.target.value)}
                                maxLength={7}
                                pattern="^#([A-Fa-f0-9]{6})$"
                                title="Enter a valid hex code like #ff0000"
                                style={{
                                    fontSize: '13px',
                                    width: '76px',
                                    height: '23px',
                                    alignContent: 'center',
                                    marginTop: '4px',
                                }}
                                />
                                {showTooltip && hoveredColor === id && (
                                    <div className="color-tooltip">
                                    <strong>Applied to:</strong>
                                    <ul>
                                        {appliedTo.map((place, index) => (
                                        <li key={index}>{place}</li>
                                        ))}
                                    </ul>
                                    </div>
                                )}
                            </div>
                            ))}
                    </div>
                                    <Form.Group className="mb-4 mt-3">
                                    <Form.Label className="form-label">Festival Effect</Form.Label>
                                        <Form.Control
                                        type="file"
                                        accept=".json,.png,.gif,.svg" // Allow multiple file types
                                    
                                        onChange={(e) => setEffectFile(e.target.files[0])} // Use new state
                                        className="form-input"
                                    /></Form.Group>


                                    <Form.Group className="mb-4">
                                    <Form.Label className="form-label">Festive Logo Effect (Lottie JSON)</Form.Label>
                                    <Form.Control
                                        type="file"                
                                        accept=".json,.png,.jpg,.jpeg,.gif,.svg" // Allow multiple file types
                                        onChange={(e) => setFestiveFile(e.target.files[0])} // New state for file
                                        className="form-input"
                                    />
                                    </Form.Group>
                                                    
                         `           <Form.Group className="mb-4" style={{ marginTop: '-17px' }}>
                                    <Form.Label className="form-label">Festival Logo (SVG/PNG)</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept=".svg,.png,.jpg,.jpeg"
                                        onChange={(e) => setFestivalLogoFile(e.target.files[0])} // New state
                                        className="form-input"
                                    />
                                    </Form.Group>
                                    {/* <Form.Group className="mb-4">
                                    <Form.Label className="form-label">Start Date & Time</Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={startDateTime}
                                        onChange={(e) => setStartDateTime(e.target.value)}
                                        className="form-input"
                                    />
                                    </Form.Group>
                        
                                    <Form.Group className="mb-4">
                                    <Form.Label className="form-label">End Date & Time</Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={endDateTime}
                                        onChange={(e) => setEndDateTime(e.target.value)}
                                        className="form-input"
                                    />
                                    </Form.Group> */}
                        
                                    <Button
                                        variant="success"
                                        onClick={handleSubmit}
                                        className="submit-btn"
                                        disabled={submitting}
                                        type="button" // Explicitly set to button to avoid form submit
                                        >
                                        {id ? 'Update Theme' : 'Save Theme'}
                                    </Button>
                                </Form>
                                </Col>
                        
                                <Col md={6} className="theme-preview1">
                                <h3 className="preview-title">Preview</h3>
                                <App
                                    ionBackgroundColor={customStyles.ionBackgroundColor}
                                    ionColorPrimary={customStyles.ionColorPrimary}
                                    ionColorSecondary={customStyles.ionColorSecondary}
                                    ionColorTertiary={customStyles.ionColorTertiary}
                                    ionHeadingColor={customStyles.ionHeadingColor}
                                    ionSubheadingColor={customStyles.ionSubheadingColor}
                                    ionTextColor={customStyles.ionTextColor}
                                    ionLogoColor={customStyles.ionLogoColor}
                                    ionCardBackground={customStyles.ionCardBackground}
                                    ionToolbarBackground={customStyles.ionToolbarBackground}
                                    ionTabBarBackground={customStyles.ionTabBarBackground}
                                    festivalEffect={customStyles.festivalEffect}
                                    festiveEffect={customStyles.festiveEffect || ''} // Pass festive effect path
                                />
                                </Col>
                            </Row>
                            </Container>
                        );
                    };
const App = ({
    ionBackgroundColor,
    ionColorPrimary,
    ionColorSecondary,
    ionColorTertiary,
    ionHeadingColor,
    ionSubheadingColor,
    ionTextColor,
    ionLogoColor,
    ionCardBackground,
    ionToolbarBackground,
    ionTabBarBackground,
    festivalEffect,
    festiveEffect,
  }) => {
    const [isHeaderHidden, setIsHeaderHidden] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);
    const [selectedTab, setSelectedTab] = useState(null); // Add this state at the top of your component
  // State for logo source
  const [logoSrc, setLogoSrc] = useState('/Logo1.svg'); // Default to colored logo

    const handleScroll = throttle(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsHeaderHidden(scrollTop > 70 && scrollTop > lastScrollTop);
      setLastScrollTop(scrollTop);
    }, 100);
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollTop]);
  
// Update logo based on toolbar background color
useEffect(() => {
    // Simple color check: dark toolbar gets white logo, light gets colored logo
    const isDarkToolbar = ionToolbarBackground.toLowerCase() === '#000000' || ionToolbarBackground.toLowerCase() === 'black';
    setLogoSrc(isDarkToolbar ? '/Logo1.svg':'/logoDark.svg');
  }, [ionToolbarBackground]);

    const defaultAddress = { location: "Sachivalaya Marg", city: "Bhubaneswar", PIN: "751013" };
    const totalPrice = 0;
  
  
    return (
      <div className="mobile-preview" style={{ position: 'relative', overflow: 'hidden', minHeight: '100vh' }}>  
        <Container 
          className="app-container"
          style={{ backgroundColor: ionBackgroundColor, color: ionTextColor , position: 'relative', minHeight: '100vh',padding:"0px" }} // Ensure container fills viewport
        >
          <header className={"app-header"} style={{ background: `linear-gradient(to bottom, ${ionColorTertiary}, ${ionBackgroundColor})` }}>
            <Row className={`header-top ${isHeaderHidden ? 'hidden' : ''}`}>
              <Col xs={8}>
                <img
                src={logoSrc}
                alt="Logo"
                className="logo"
                style={{ filter: ionLogoColor ? `drop-shadow(0 0 2px ${ionLogoColor})` : 'none' }}
              />
               
              </Col>
              <Col xs={2} className="text-center">
                <Image src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/web2022/nav_language_icon.svg" className="icon" />
              </Col>
              <Col xs={2} className="text-center">
                <CgProfile className="profile-icon" style={{ color: ionHeadingColor }} />
              </Col>
            </Row>
            <Row className="address-bar" style={{ backgroundColor: ionColorTertiary }}>
              <div className="address-content">
                <MdLocationPin className="location-icon" style={{ color: ionHeadingColor }} />
                <span className="address-text" style={{ color: ionTextColor , fontWeight: 'bold',fontSize: '11px'}}>
                  {defaultAddress.location}, {defaultAddress.city}, {defaultAddress.PIN}
                </span>
                <IoMdArrowDropdown style={{ color: ionHeadingColor , fontSize:'20px' }}  />
              </div>
            </Row>
          </header>

          <main className="app-main" style={{ position: 'relative', zIndex: 2, minHeight: 'calc(100vh - 100px)' }}> {/* Ensure content height */}
            <Row className="greeting">
              <Col>
                <span className="greeting-text" >Good Evening 🌞, User</span>
                <p className="subheading" style={{ color: 'grey' }}>
                  Let’s make our environment cleaner
                </p>
              </Col>
            </Row>

            <Row className="dashboard-header">
              <Col>
                <label className="dashboard-title" style={{ color: ionTextColor }}>Your Dashboard</label>
                <CiShare2 className="share-btn" style={{ color: ionHeadingColor, cursor: 'pointer' }} />
              </Col>
            </Row>

            <Row className="card-row">
              <Col xs={6} className="d-flex align-items-stretch">
                <Card className="dashboard-card equal-height" style={{ backgroundColor: '#b454d0', flex: 1 , position: 'relative', zIndex: 2 }}>
                  <div className="card-content">
                    <p className="card-label">₹ </p> 
                    <br/>
                    <p className="card-label">Earned So Far</p>
                  </div>
                </Card>
              </Col>
              <Col xs={6} className="d-flex align-items-stretch">
                <Card className="dashboard-card equal-height" style={{ backgroundColor: "#afcf44", flex: 1,position: 'relative', zIndex: 2 }}>
                  <div className="card-content">
                    <p className="card-label">Pickups</p>
                  </div>
                </Card>
              </Col>
            </Row>

            <Row className="card-row">
              <Col xs={6} className="d-flex align-items-stretch">
                <Card className="dashboard-card equal-height" style={{ backgroundColor: "#1cdfa5", flex: 1 , position: 'relative', zIndex: 2 }}>
                  <div className="card-content">
                    <p className="card-label">~<sub>kgs</sub> </p>
                    <p className="card-label">waste </p>
                  </div>
                </Card>
              </Col>
              <Col xs={6} className="d-flex align-items-stretch">
                <Card className="dashboard-card equal-height" style={{ backgroundColor: "#e9b065", flex: 1, position: 'relative', zIndex: 2 }}>
                  <div className="card-content">
                    <p className="card-label">~<sub>kgs</sub> </p>
                    <p className="card-label">CO<sub>2</sub> Averted </p>
                  </div>
                </Card>
              </Col>
            </Row>
            <Row className="card-row">
              <Col xs={6} className="d-flex align-items-stretch">
                <Card className="dashboard-card equal-height" style={{ backgroundColor: "#4fea66", flex: 1 }}>
                  <div className="card-content">
                    <p className="card-label">~</p>
                    <p className="card-label">Trees Saved</p>
                  </div>
                </Card>
              </Col>
              <Col xs={6} className="d-flex align-items-stretch">
                <Card className="dashboard-card equal-height" style={{ backgroundColor: "lightseagreen", flex: 1 }}>
                  <div className="card-content">
                    <p className="card-label">~<sub>Ltrs</sub> </p>
                    <p className="card-label">Fuel Saved</p>
                  </div>
                </Card>
              </Col>
            </Row>

            <div className="scrap-rate-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' ,position: 'relative', paddingBottom: '0px' }}>    
              <h5  style={{ color: ionTextColor }}>Todays Scrap Rate</h5>
           
                <p
                //   variant="link"
                  className="view-all-btn"
                  style={{
                    color: ionHeadingColor,
                    // background: 'var(--ion-color-primary)',
                    textTransform: 'none',
                    borderRadius: '5px',
                    paddingTop: '16px',
                    paddingBottom: '10px',
                  }}
                >
                  View All
                </p>
            
            </div>
            <Card className="impact-card" style={{ backgroundColor: '#efffdb', margin: '5px', position: 'relative', zIndex: 2 }}>

              <Row style={{backgroundColor: ionColorTertiary}}>
                <Col xs={6} style={{ padding: '1vh', marginTop: '12px', paddingLeft: '4vh' }}>
                  <div className="impact-text">
                    <span style={{ color: 'black', fontSize: '2.5vh', fontWeight: 'bold' }}>
                      See what the Recycle Pay community is achieving together
                    </span>
                  </div>
                  <Button
                    variant="primary"
                    style={{
                      padding: '1vh',
                      marginTop: '10px',
                      backgroundColor: ionColorPrimary,
                      border: 'none',
                      textTransform: 'none',
                      color: 'white',
                      borderRadius: '5px',
                      paddingTop: '10px',
                      paddingBottom: '10px',
                    }}
                  >
                    Impact
                  </Button>
                </Col>
                <Col xs={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1vh' }}>
                  <Image
                    src="/earth.svg"
                    alt="Earth"
                    style={{ height: '80%', borderRadius: '50%', marginRight: '10px' }}
                  />
                </Col>
              </Row>
            </Card>

            <div className="swiper-container">
            <Row className="card-row" style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto' }}>
                <Col xs={12} style={{ flex: '0 0 100%', maxWidth: '100%', padding: '0 5px' }}>
                <Card className="dashboard-card extra-card">
                    <div className="card-content">
                    <Image
                        src="/referAndEarn3.gif"
                        alt="Refer and Earn"
                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} // Preserve aspect ratio
          />
        </div>
      </Card>
    </Col>
    <Col xs={12} style={{ flex: '0 0 100%', maxWidth: '100%', padding: '0 5px' }}>
      <Card className="dashboard-card extra-card">
        <div className="card-content">
          <Image
            src="/donateBanner.gif"
            alt="Donate Banner"
            style={{ width: '100%', height: 'auto', objectFit: 'contain' }} // Preserve aspect ratio
          />
        </div>
      </Card>
    </Col>
  </Row>
</div>
  </main>
   {/* New static tab bar inside mobile-preview */}
   <div className="preview-tab-bar" style={{ position: 'sticky', bottom: 0, zIndex: 1000  }}>
        <div className="tab-bar-content" style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', backgroundColor: ionTabBarBackground, padding: '10px 0',marginBottom: '10px' }}>
          <div className="tab-item" onClick={() => setSelectedTab('home')}>
            <FaHome size={20} style={{ color: selectedTab === 'home' ? ionHeadingColor : ionTextColor}} />
            <span className="tab-label" style={{ color: selectedTab === 'home' ? ionHeadingColor : ionTextColor, fontSize: '12px' }}>Home</span>
          </div>
          <div className="tab-item" onClick={() => setSelectedTab('sell-scrap')}>
            <FaTag size={20} style={{ color: selectedTab === 'sell-scrap' ? ionHeadingColor : ionTextColor }} />
            <span className="tab-label" style={{ color: selectedTab === 'sell-scrap' ? ionHeadingColor : ionTextColor, fontSize: '12px' }}>Sell Scrap</span>
          </div>
          <div className="tab-action-button" style={{ backgroundColor: '#f57c00', borderRadius: '50%', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: '#fff', fontSize: '24px' }}><PiBracketsSquareBold /></span>
          </div>
          <div className="tab-item" onClick={() => setSelectedTab('ecoshop')}>
            <FaStore size={20} style={{ color:selectedTab === 'ecoshop' ? ionHeadingColor : ionTextColor }} />
            <span className="tab-label" style={{ color: selectedTab === 'ecoshop' ? ionHeadingColor : ionTextColor, fontSize: '12px' }}>EcoShop</span>
          </div>
          <div className="tab-item" onClick={() => setSelectedTab('events')}>
            <FaCalendarAlt size={20} style={{ color: selectedTab === 'events' ? ionHeadingColor : ionTextColor }} />
            <span className="tab-label" style={{ color: selectedTab === 'events' ? ionHeadingColor : ionTextColor, fontSize: '12px' }}>Events</span>
          </div>
        </div>
      </div>
        </Container>      
       
     </div>
    );
  };
export default ThemeSelector;
